module.exports = __webpack_public_path__ + "images/choices/wusong-234827c3566dd19c6d195dddc9e3f053.png";